import { Space, API } from "@thenounproject/lingo-core";
import { createQueryAction } from "@actions/actionCreators";

type Args = {
  spaceId: number;
};

type Account = Pick<Space, "card" | "charges">;

const [useBillingData, fetchBillingData] = createQueryAction<Args, Account, Account>(
  {
    entity: "spaces",
    action: "fetchBillingData",
    denormalize: false,
  },
  async ({ args }) => {
    const res = await API.call<{ space: Space }>({
      endpoint: `spaces/${args.spaceId}/account`,
      method: "GET",
      normalize: false,
    });
    const { balance, card, charges } = res.result.space;
    return {
      result: { balance, card, charges },
    };
  }
);

export default useBillingData;
export { fetchBillingData };
